document.addEventListener("DOMContentLoaded", function () {

console.log("menu-inject.js is loaded and running.");

  function injectDropdownContent() {
    // Locate the target menu item
    const targetMenuItem = document.querySelector('.tf_custom_menu_item');

    if (targetMenuItem) {
      // Locate the hidden section container
      const sectionContainer = document.getElementById('menu-inject-section-container');

      if (sectionContainer) {
        // Extract the dropdown content
        const customContent = sectionContainer.querySelector('.dropdown-content');

        if (customContent) {
          // Find the submenu container inside the target menu item
          const submenu = targetMenuItem.querySelector('.tmenu_submenu');

          if (submenu) {
            // Clone the dropdown content and append it
            const clonedContent = customContent.cloneNode(true);
            submenu.appendChild(clonedContent);
            console.log("Dropdown content injected successfully.");
          } else {
            console.error("Submenu container not found.");
          }
        } else {
          console.error("No dropdown content found.");
        }
      } else {
        console.error("Menu Inject Section container not found.");
      }
    } else {
      console.error("Target menu item not found.");
    }
  }

  // Retry until the Qikify menu is ready
  const maxAttempts = 10;
  let attempts = 0;
  document.addEventListener("DOMContentLoaded", function () {
  function injectDropdownContent() {
    const targetMenuItem = document.querySelector('.tf_custom_menu_item');
    if (targetMenuItem) {
      const sectionContainer = document.getElementById('menu-inject-section-container');
      if (sectionContainer) {
        const customContent = sectionContainer.querySelector('.dropdown-content');
        if (customContent) {
          const submenu = targetMenuItem.querySelector('.tmenu_submenu');
          if (submenu) {
            const clonedContent = customContent.cloneNode(true);
            submenu.appendChild(clonedContent);
            console.log("Dropdown content injected successfully.");
          } else {
            console.error("Submenu container not found.");
          }
        } else {
          console.error("No dropdown content found.");
        }
      } else {
        console.error("Menu Inject Section container not found.");
      }
    } else {
      console.error("Target menu item not found.");
    }
  }

  // Monitor DOM changes
  const observer = new MutationObserver(() => {
    const menuItem = document.querySelector('.tf_custom_menu_item');
    const submenu = document.querySelector('.tmenu_submenu');
    if (menuItem && submenu) {
      console.log("Menu item and submenu detected by MutationObserver.");
      injectDropdownContent();
      observer.disconnect(); // Stop observing once injected
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

});
